import React from 'react'
import { describeAttributeValue, formatDuration, formatPrice } from '../../../utils/pricing'
import styles from './serviceSummary.module.css'

function ServiceSummary({
    productName = '',
    basePrice = 0,
    baseDuration = 0,
    selectedAttributes = [],
    totalPrice = 0,
    totalDuration = 0,
    canSave = false,
    onSaveClick = () => {},
    saveButtonLabel = 'Add to Appointment',
}) {
  return (
    <div className={styles.summary}>
        <h1 className={styles.title}>Service Summary</h1>
        <div className={styles.card}>
            <h3 className={styles.productName}>{productName || 'Service'}</h3>
            <ul className={styles.lineItems}>
                <li className={styles.lineItem}>
                    <span className={styles.lineLabel}>Base service</span>
                    <span className={styles.lineMeta}>{formatPrice(basePrice)} · {formatDuration(baseDuration)}</span>
                </li>
                {selectedAttributes.map((attribute) => (
                    <li key={attribute.attribute_value_id ?? attribute.attribute_name} className={styles.lineItem}>
                        <span className={styles.lineLabel}>
                            <span className={styles.attributeName}>{attribute.attribute_name}:</span>
                            <span className={styles.attributeValue}>{attribute.attribute_value}</span>
                        </span>
                        <span className={styles.lineMeta}>{describeAttributeValue(attribute)}</span>
                    </li>
                ))}
            </ul>
            {selectedAttributes.length === 0 && (
                <p className={styles.emptyState}>No options selected yet.</p>
            )}
        </div>
        <div className={styles.footer}>
            <div className={styles.totals}>
                <div className={styles.totalsLabel}>
                    <span>Total</span>
                    <span className={styles.totalsMeta}>{formatDuration(totalDuration)}</span>
                </div>
                <span className={styles.totalsPrice}>{formatPrice(totalPrice)}</span>
            </div>
            <button type="button" className={styles.saveButton} onClick={onSaveClick} disabled={!canSave}>
                {saveButtonLabel}
            </button>
        </div>
    </div>
  )
}

export default ServiceSummary
